<div class="container">

    @if (errorMessageKey) {
        <header class="pt-5 pb-3 text-center">
            <div class="alert alert-warning" role="alert">
                <h2 class="fw-normal">
                    <i class="far fa-warning"></i> {{errorMessageKey|translate}}
                </h2>
            </div>
        </header>
    }
    @else {
        <header class="pt-5 pb-3 text-center text-secondary">
            <h1 class="pb-md-3 pt-2 fs-3 fw-normal">
                @if(userRequestBacklog?.backlog_infos.byType.PollRequest > 1){
                    Answer recorded. Next question...
                    <p class="fs-6 fst-italic">
                    <i [ngPlural]="userRequestBacklog?.backlog_infos.byType.PollRequest">
                        {{userRequestBacklog?.backlog_infos.byType.PollRequest}}
                        <ng-template ngPluralCase="=1">{{'poll_request.remaining_question' | translate}}</ng-template>
                        <ng-template ngPluralCase="other">{{'poll_request.remaining_questions' | translate}}</ng-template>
                    </i></p>
                } @else {
                    {{'add_other_feedback.title' | translate}}
                    @if(pollPublishDate){
                        <p class="fs-6 fst-italic">{{'add_other_feedback.results_date' | translate}} {{pollPublishDate | date:'mediumDate' }}</p>
                    }
                }
            </h1>
        </header>
    }

    <div class="row">
        <div class="form mt-4 col-md-9 mx-auto">
            <div class="row">
                <div class="col-md-6 mb-3 mb-md-0">
                    @if(!wellbeingResources && userRequestBacklog){
                        <user-requests context="addOtherFeedback"
                                       [request]="userRequestBacklog"
                                       [teamId]="teamId"
                                       [teams]="teams"
                                       [author]="author"
                                       (onCreateTimelineItemAfterRequest)="onCreateTimelineItemAfterRequest($event)"></user-requests>
                    } 
                    @if(wellbeingResources) {
                        <div class="card text-center bg-white h-100 border rounded border-3 border-danger border-opacity-50">
                            <div class="card-body">
                                <h4 class="card-title">{{wellbeingResources.title}}</h4>
                                <p class="card-text">{{wellbeingResources.descriptionLine1}}</p>
                                <div class="my-4">
                                    <span class="text-secondary"><i class="fa-thin fa-head-side-heart fa-8x"></i></span>
                                </div>
                                <div class="my-4">
                                    <p class="card-text">{{wellbeingResources.descriptionLine2}}</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <a [href]="wellbeingResources.ctaUrl" target="_blank" class="btn btn-primary py-2">{{wellbeingResources.ctaLabel}}</a>
                            </div>
                        </div>
                    }
                </div>
                <div class="col-md-6">
                    <div class="card text-center bg-white h-100">
                        <div class="card-body">
                            <h4 class="card-title">{{'add_other_feedback.timeline.desc' | translate}}</h4>
                            <div class="my-4 image-container">
                                <img src="/assets/images/add_comment/talking-people.svg" class="h-100">
                            </div>
                        </div>
                        <div class="card-footer">
                            <a class="btn btn-primary py-2" data-cy="next-btn" [routerLink]="landingPage">{{'add_other_feedback.timeline.continue' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row pt-5">
            <div class="col-md-9 mx-auto">
                @for (info of kudosSuccess; track info.id){
                    <a [routerLink]="['/home', info.teamId, {fragment: info.id}]"
                       class="alert alert-success text-decoration-none d-block">
                       {{info.content}}
                    </a>
                }
            </div>
        </div>
    </div>
</div>